import React from 'react';
import { withPrefix } from 'gatsby'

const FeaturedEvent = (props) => {
  const { event } = props;

  return (
    <div className="featured-event">
      <img src={withPrefix(`/images/events/${event.filename}`)} alt={event.title} />
      <div className="featured-event-text">
        <h1>{event.title}</h1>
        <div dangerouslySetInnerHTML={{__html: event.text}} />
      </div>
    </div>
  );
}

export default FeaturedEvent;
